import { render, staticRenderFns } from "./createPromotion.vue?vue&type=template&id=3db5c4c3"
import script from "./createPromotion.vue?vue&type=script&lang=js"
export * from "./createPromotion.vue?vue&type=script&lang=js"
import style0 from "./createPromotion.vue?vue&type=style&index=0&id=3db5c4c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports